export default "__VITE_ASSET__rwPJkObS__"